import { useCallback, useEffect, useRef, useState } from 'react'

const IDLE_TIMEOUT_MS = 5 * 60 * 1000

export function useScannerIdleTimer(active: boolean) {
  const [isIdle, setIsIdle] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }

  const startTimer = useCallback(() => {
    clearTimer()
    timerRef.current = setTimeout(() => setIsIdle(true), IDLE_TIMEOUT_MS)
  }, [])

  const resume = useCallback(() => {
    setIsIdle(false)
    startTimer()
  }, [startTimer])

  useEffect(() => {
    if (active) {
      startTimer()
    } else {
      clearTimer()
      setIsIdle(false)
    }
    return clearTimer
  }, [active, startTimer])

  return { isIdle, resume }
}
